function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["loading", "prefixClass", "className", "style", "onClick", "disabled", "size", "outline", "flat", "rounded", "children", "href", "color"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect, forwardRef } from "react";
import classNames from "classnames";
import { jsx as _jsx } from "react/jsx-runtime";
var Button = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classNames2;
  var loading = props.loading,
    prefixClass = props.prefixClass,
    className = props.className,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _onClick = props.onClick,
    disabled = props.disabled,
    size = props.size,
    outline = props.outline,
    flat = props.flat,
    rounded = props.rounded,
    children = props.children,
    href = props.href,
    color = props.color,
    buttonProps = _objectWithoutProperties(props, _excluded);
  var $button = ref || /*#__PURE__*/React.createRef();
  useEffect(function () {
    if ($button.current && rounded && typeof rounded !== "boolean") {
      $button.current.style.setProperty("--radius", rounded);
    }
  }, []);
  if (href) {
    var _classNames;
    return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
      href: href,
      ref: $button,
      className: classNames("".concat(prefixClass, "Btn"), "".concat(prefixClass, "Btn--").concat(size), className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixClass, "Color--").concat(color), color), _defineProperty(_classNames, "".concat(prefixClass, "Btn--outline"), outline), _defineProperty(_classNames, "".concat(prefixClass, "Btn--flat"), flat), _defineProperty(_classNames, "".concat(prefixClass, "Btn--rounded"), rounded), _defineProperty(_classNames, "".concat(prefixClass, "Btn--loading"), loading), _classNames)),
      "data-size": size,
      "data-color": color,
      "data-outline": outline,
      "data-flat": flat,
      "data-rounded": rounded,
      "data-loading": loading,
      "data-disabled": disabled,
      style: style,
      onClick: function onClick(ev) {
        if (loading || disabled) {
          ev.preventDefault();
          return;
        }
        _onClick && _onClick(ev);
      }
    }, buttonProps), {}, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
    type: "button",
    ref: $button,
    disabled: disabled,
    className: classNames("".concat(prefixClass, "Btn"), "".concat(prefixClass, "Btn--").concat(size), className, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixClass, "Color--").concat(color), color), _defineProperty(_classNames2, "".concat(prefixClass, "Btn--outline"), outline), _defineProperty(_classNames2, "".concat(prefixClass, "Btn--flat"), flat), _defineProperty(_classNames2, "".concat(prefixClass, "Btn--rounded"), rounded), _defineProperty(_classNames2, "".concat(prefixClass, "Btn--loading"), loading), _classNames2)),
    "data-size": size,
    "data-color": color,
    "data-outline": outline,
    "data-flat": flat,
    "data-rounded": rounded,
    "data-loading": loading,
    style: style,
    onClick: function onClick(ev) {
      if (loading || disabled) {
        return;
      }
      _onClick && _onClick(ev);
    }
  }, buttonProps), {}, {
    children: children
  }));
});
Button.defaultProps = {
  prefixClass: "yk",
  size: "medium",
  color: "primary"
};
export default Button;